export default __webpack_public_path__ + "static/media/User.9fab5dd9.svg";